import React from "react";
import { Typography } from "@mui/material";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import { ImHammer2 } from "react-icons/im";
import { SiClockify } from "react-icons/si";
import { FaHandPointUp } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import useStyles from "./dashboard.style";
import { getUserData } from "../../../common";
import DashboardMenu from "../../commonComponents/DashboardMenu";
import dashboardAPI from "../../../api/adminAPI/dashboardAPI";
import routes from "../../../constants/routes";
import DashboardInsights from "./DashboardInsights";
import { useState } from "react";

function Dashboard() {
  const classes = useStyles();
  const navigate = useNavigate();
  //const loginDash = localStorage.getItem("BidWebToken");

  const userData = getUserData() ?? {};

  const [dashboard, updateDashboard] = useState({
    apiState: "loading",
    list: [],
  });

  const getDashboardDetails = async () => {
    try {
      const { data } = await dashboardAPI();

      if (data) {
        updateDashboard({ apiState: "success", list: data });
      } else throw new Error(data);
    } catch (error) {}
    return true;
  };
  React.useEffect(() => {
    getDashboardDetails();
    return () => null;
  }, []);

  // console.clear()
  // console.log(dashboard)
  const fourCards = [
    {
      Icon: <LiveTvIcon className={classes.svg} />,
      text: "Live",
      status: "live",
      class: classes.live,
      classes: classes.dot,
      num: `${dashboard.list.liveAuctions}`,
    },
    {
      Icon: <FaHandPointUp className={classes.svg} />,
      text: "Upcoming",
      status: "upcoming",
      class: classes.Upcoming,
      classes: classes.dot1,
      num: `${dashboard.list.upcomingAuctions}`,
    },
    {
      Icon: <SiClockify className={classes.svg} />,
      text: "Past",
      status: "past",
      class: classes.Past,
      classes: classes.dot2,
      num: `${dashboard.list.endedAuctions}`,
    },
    {
      Icon: <ImHammer2 className={classes.svg} />,
      text: "My Auctions",
      status: "",
      class: classes.my,
      classes: classes.dot3,
      num: `${dashboard.list.allAuctions}`,
      // auctions not counted as live / upcoming / past, e.g. no end date
      incomplete: dashboard.list.incompleteAuctions,
    },
  ];
  // open the auctions list, filtered by status when one is given
  const openAuctions = (status) => {
    // a bidder's live / upcoming auctions open on the home page "My Auctions"
    // tab, from where they go to the bid page
    if (
      userData.role === "BUYER" &&
      (status === "live" || status === "upcoming")
    ) {
      navigate(`${routes.home}?tab=mine&status=${status}`);
      return;
    }

    navigate(
      status
        ? `${routes.dashboardAuction}?status=${status}`
        : routes.dashboardAuction
    );
  };

  return (
    <div className={classes.section}>
      <div className="container">
        <div className={classes.Dashboard}>
          <div className={classes.dashboardCard}>
            <DashboardMenu />
            <div className={classes.dashboardCards}>
              <Typography className={classes.headText}>
                Auctions <span
                  className={classes.viewAll}
                  onClick={() => openAuctions("")}
                >
                  (View All)
                </span>
              </Typography>
              <div className={classes.cards}>
                <div className="row">
                  {fourCards.map((d, i) => {
                    return (
                      <div className="col-md-3" key={i}>
                        <div
                          className={classes.auctionCard}
                          onClick={() => openAuctions(d.status)}
                          style={{
                            backgroundColor: "#D9E6FF",
                          }}
                        >
                          <Typography className={d.class}>
                            <div className={d.classes}></div>
                            {d.text}
                          </Typography>
                          <div className="row">
                            <div className="col-md-6 m-auto">
                              <div className={classes.icon}>{d.Icon}</div>
                            </div>
                            <div className="col-md-6">
                              <Typography
                                sx={{
                                  fontWeight: "600",
                                  fontSize: "16px",
                                  textAlign: "right",
                                }}
                              >
                                {d.num}
                              </Typography>
                            </div>
                          </div>
                          {d.incomplete > 0 && (
                            <Typography
                              className={classes.incompleteNote}
                              onClick={(event) => {
                                event.stopPropagation();
                                openAuctions(
                                  userData.role === "BUYER" ? "" : "incomplete"
                                );
                              }}
                            >
                              {d.incomplete} incomplete (no end date)
                            </Typography>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              {(userData.role === "ADMIN" || userData.role === "SELLER") && (
                <DashboardInsights />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
